<template>
  <div class="app-container">
    <el-tabs v-model="activeName" >
      <el-tab-pane label="仓库配置" name="one" style="">
        <cangku v-if="activeName=='one'"></cangku>
      </el-tab-pane>
      <el-tab-pane label="库存颜色" name="three">
        <yanse v-if="activeName=='three'"></yanse>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>
<script>
import cangku from '@/views/wms-stock/kehuPiezhiJF/cangku.vue'
import yanse from '@/views/wms-stock/kehuPiezhiJF/yanse.vue'
export default {
  components: {
    cangku,
    yanse
  },
  data () {
    return {
      activeName: 'one'
    }
  },
  created () {
    if (this.$route.query.ZDFlag) {
      this.activeName = 'two'
    } else {
      this.activeName = 'one'
    }
  }
}
</script>
<style scoped lang='less'>
/deep/.el-tabs--card>.el-tabs__header .el-tabs__item.is-active {
    background-color: #0c46a2 !important;
    color: #fff;
}
/deep/.el-tabs__header{
  margin-bottom: 0;
}
</style>
